module.exports = __webpack_public_path__ + "img/service1.87c0c0f.png";